// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2548":"d03f85fe","2802":"df0ff35d","6463":"b6ece8b7","8378":"b6ece8b7"}[chunkId] + ".chunk.css";
};